module.exports = __webpack_public_path__ + "img/dolar.0ac36e2b.svg";